import styled from "styled-components";
import { media } from "../../../theme/theme";
import { MarketingLinkHoverEffect } from "../../ReusableStyledComponents/MarketingLinkHover";
import { Body, H3, H4 } from "../../Typography";

const BRLG = 900;

export const SlideWrapper = styled.div`
    display: flex;
    max-width: 1100px;
    margin: 0 auto;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 12px;

    ${media.phone} {
        padding: 0 60px;
    }

    ${media.custom(BRLG)} {
        flex-wrap: nowrap;
        margin: 20px auto 0;
        min-height: 502px;
    }

    > div {
        &:first-child {
            width: 100%;
            max-width: 500px;
            margin: 0 auto;

            ${media.custom(BRLG)} {
                width: 50%;
                max-width: 580px;
                margin-top: 20px;
                margin-right: auto;
                margin-left: 0;
            }
        }

        &:nth-child(2) {
            width: 100%;

            ${media.custom(BRLG)} {
                width: auto;
            }
        }
    }

    img {
        width: 108%;
        height: auto;
    }
`;

export const SlideText = styled.div`
    max-width: 445px;
    margin: 0 auto;

    ${media.custom(BRLG)} {
        padding: 0 0 0 25px;
        width: auto;
        margin-top: 50px;
        padding: 0 0 0 35px;
    }

    ${Body} {
        color: ${({ theme }) => theme ? theme.marketing.colors.blackPearl80 : null};
    }

    ul {
        padding: 0 0 0 25px;

        ${media.custom(BRLG)} {
            padding: 0;
        }

        margin-bottom: 40px;

        li {
            position: relative;

            &:not(:last-child) {
                margin-bottom: 30px;
            }

            &:before {
                position: absolute;
                content: "";
                width: 16px;
                height: 16px;
                top: 7px;
                left: -29px;
                background-image: url("/authory_static_files/images/slider/slider-bullet.png");
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
            }
        }
    }

    ${H4} {
        color: ${({ theme }) => theme ? theme.marketing.colors.dodgerBlue100 : null};
    }
    
    ${MarketingLinkHoverEffect}
    a {
        text-decoration: none;
        color: ${({ theme }) => theme ? theme.marketing.colors.dodgerBlue100 : null};

        &:hover {
            ${H4} {
                color: ${({ theme }) => theme ? theme.marketing.colors.chathamsBlue : null};
            }
        }
    }
`;

export const SlideFeatureGraphic = styled.div`
    > div {
        &:first-child {
            display: none;

            ${media.custom(BRLG)} {
                display: block;
            }
        }
    }
`;

export const FeatSliderTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    text-align: center;

    ${media.custom(BRLG)} {
        text-align: left;
    }

    > div {
        &:nth-child(1),
        &:nth-child(3) {
            cursor: pointer;
            display: block;

            ${media.custom(BRLG)} {
                display: none;
            }
        }

        ${H3} {
            padding: 0 10px;
            font-size: 22px;
            line-height: 24px;

            ${media.custom(BRLG)} {
                font-size: 32px;
                line-height: 42px;
            }
        }
    }
`;